
    import './styles.scoped.css';
    export default {
  "resize-active": "awsui_resize-active_x7peu_10e5l_5",
  "resizer": "awsui_resizer_x7peu_10e5l_10",
  "resizer-active": "awsui_resizer-active_x7peu_10e5l_26",
  "tracker": "awsui_tracker_x7peu_10e5l_36"
};
  